'use client';

import { useTranslation } from 'next-i18next';
import { LinkStyled } from '@components/common';
import { useAuthClient } from '@root/src/hooks';

interface StandardBundleProps {
  standardBundles?: ApiSchema<'OfferBundle'>[];
}

/**
 * @description StandardBundle
 */
export const StandardBundle = ({ standardBundles }: StandardBundleProps) => {
  const { t } = useTranslation('common');

  const { isSafeAuth } = useAuthClient();


  if (!standardBundles || standardBundles.length === 0) {
    return null;
  }

  const firstBundle = standardBundles[0];

  const destinationPath = `/job-add/edit?selectedPackageId=${firstBundle?.id ?? ''}`;

  return (
    <div className="pt-10">
      <div className="relative text-left">
        {t('service.page.start')}
        <LinkStyled
          href={isSafeAuth
            ? destinationPath
            : `/login?targetPath=${encodeURIComponent(destinationPath)}`}
          styling="none"
          size="sm"
          className="ml-2 text-primary underline"
        >
          {t('global.label.activate.job')}
        </LinkStyled>
      </div>


    </div>
  );
};
